<div class="sticky-header">
    <span class="sticky-title">
        @if (incident) { #{{ incident.incidentNumber }} } @else { Breakdown }
    </span>
    <div class="header-actions">
        <button nz-button nzType="text" nzSize="large" (click)="onSubscribeToBreakdownUpdates()" class="refresh-btn">
            <nz-icon nzType="whats-app" nzTheme="outline" /> Subscribe
        </button>
        <button nz-button nzType="text" nzSize="large" (click)="onRefresh()" [nzLoading]="isLoading" class="refresh-btn">
            <nz-icon nzType="reload" nzTheme="outline" /> Refresh
        </button>
    </div>
</div>
<div class="unauthed-container chat-section">
    <app-incident-chat [incidentId]="currentIncidentId" [incidentNumber]="incident?.incidentId === currentIncidentId ? incident?.incidentNumber || '' : ''"
        [senderType]="chatSender" [refreshKey]="incident" [notificationsEnabled]="incident?.incidentId === currentIncidentId" />
</div>
@if (isLoading) {
    <nz-skeleton [nzActive]="true"></nz-skeleton>

} @else if (declined) {
    <div class="card unavailable-card">
        <nz-result
            nzStatus="error"
            nzTitle="Breakdown Declined"
            nzSubTitle="You have declined this breakdown.">
        </nz-result>
    </div>
} 
@else if (incidentUnavailable) {
<div class="unauthed-container">
    <div class="card unavailable-card">
        <nz-result
            [nzIcon]="incidentUnavailable.reason === 'closed' ? 'check-circle' : 'stop'"
            [nzStatus]="incidentUnavailable.reason === 'closed' ? 'success' : 'warning'"
            [nzTitle]="incidentUnavailable.reason === 'closed' ? 'Breakdown Closed' : 'Not Yet Assigned'"
            [nzSubTitle]="incidentUnavailable.reason === 'closed'
                ? 'This breakdown has already been completed or closed and cannot be managed via this app.'
                : 'This breakdown has not yet been assigned to a technician and cannot be managed via this app.'">
        </nz-result>
    </div>
</div>
} @else {
<div class="unauthed-container">

    <!-- ===== SECTION 1: ACCEPT / DECLINE (statusId 5 or 6) ===== -->
    @if (incident && (incident.statusId === 5 || incident.statusId === 6)) {
    <div class="card accept-decline-card">
        <h2 class="card-title">
            <nz-icon nzType="alert" nzTheme="outline" /> Breakdown Request
        </h2>
        <p class="card-subtitle">You have been assigned to a breakdown. Please accept or decline.</p>
        <div class="accept-decline-buttons">
            <button nz-button nzType="primary" nzSize="large" nzBlock class="accept-btn" (click)="onAccept()" [nzLoading]="isAccepting">
                <nz-icon nzType="check-circle" nzTheme="outline" />
                Accept
            </button>
            <button nz-button nzDanger nzSize="large" nzBlock class="decline-btn" (click)="declined = true">
                <nz-icon nzType="close-circle" nzTheme="outline" />
                Decline
            </button>
        </div>
    </div>
    }

    

    <!-- ===== SECTION 2: ETA CALCULATOR (statusId 7, no dtTechConfirmedEta) ===== -->
    @if (incident && incident.statusId >= 7 && !incident.incidentActions?.dtTechConfirmedEta) {
    <div class="card eta-calculator-card">
        <h2 class="card-title">
            <nz-icon nzType="clock-circle" nzTheme="outline" /> ETA Calculator
        </h2>
        <div class="eta-table">
            <div class="eta-row">
                <span class="eta-label">Travel Time</span>
                <div class="eta-value">
                    <nz-input-number
                        [(ngModel)]="travelTimeMinutes"
                        [nzMin]="0"
                        [nzStep]="5"
                        [nzFormatter]="minuteFormatter"
                        [nzParser]="minuteParser"
                        style="width: 120px;">
                    </nz-input-number>
                </div>
            </div>
            <div class="eta-row">
                <span class="eta-label">Prep Time</span>
                <div class="eta-value eta-readonly">
                    {{ prepTimeMinutes }} min
                </div>
            </div>
            <div class="eta-row">
                <span class="eta-label">Delay</span>
                <div class="eta-value">
                    <nz-input-number
                        [(ngModel)]="delayMinutes"
                        [nzMin]="0"
                        [nzStep]="5"
                        [nzFormatter]="minuteFormatter"
                        [nzParser]="minuteParser"
                        style="width: 120px;">
                    </nz-input-number>
                </div>
            </div>
            <div class="eta-row eta-total-row">
                <span class="eta-label"><strong>Calculated ETA</strong></span>
                <div class="eta-value">
                    @if (calculatedEtaMinutes == null) {
                        <span>Travel time unavailable. Enter travel time to confirm the ETA.</span>
                    } @else {
                        <strong>{{ calculatedEtaMinutes }} min</strong>
                        <span class="eta-time-badge">{{ calculatedEtaTime }}</span>
                    }
                </div>
            </div>
        </div>
        <div style="margin-top: 12px;">
            <button nz-button nzType="primary" nzSize="large" nzBlock (click)="onCommitEta()" [nzLoading]="isCommittingEta" [disabled]="calculatedEtaMinutes == null">
                <nz-icon nzType="check" nzTheme="outline" />
                Commit ETA
            </button>
        </div>
    </div>
    }

    <!-- ===== SECTION 3: TIMELINE (dtTechConfirmedEta present) ===== -->
    @if (incident && incident.incidentActions?.dtTechConfirmedEta) {
    <div class="card timeline-card">
        <h2 class="card-title">
            <nz-icon nzType="history" nzTheme="outline" /> Timeline
        </h2>
        <div class="timeline-table">
            <div class="timeline-row" [class.done]="incident.dtLogged">
                <span class="timeline-label">Logged</span>
                <span class="timeline-value">{{ incident.dtLogged ? ((incident.dtLogged + 'Z') | date:'HH:mm') : '' }}</span>
            </div>
            <div class="timeline-row" [class.done]="incident.incidentActions?.dtSPAssigned">
                <span class="timeline-label">Provider Allocated</span>
                <span class="timeline-value">{{ incident.incidentActions?.dtSPAssigned ? ((incident.incidentActions!.dtSPAssigned + 'Z') | date:'HH:mm') : '' }}</span>
            </div>
            <div class="timeline-row" [class.done]="incident.incidentActions?.dtTechAssigned">
                <span class="timeline-label">Technician Accepted</span>
                <span class="timeline-value">{{ incident.incidentActions?.dtTechAssigned ? ((incident.incidentActions!.dtTechAssigned + 'Z') | date:'HH:mm') : '' }}</span>
            </div>
            <div class="timeline-row" [class.done]="incident.incidentActions?.dtTechConfirmedEta">
                <span class="timeline-label">ETA Confirmed</span>
                <span class="timeline-value">{{ incident.incidentActions?.dtTechConfirmedEta ? ((incident.incidentActions!.dtTechConfirmedEta + 'Z') | date:'HH:mm') : '' }}</span>
            </div>
            <div class="timeline-row" [class.done]="incident.breakdownTechnicianDriverEta">
                <span class="timeline-label">ETA</span>
                <span class="timeline-value">
                    @if (incident.breakdownTechnicianDriverEta) {
                        {{ (incident.breakdownTechnicianDriverEta + 'Z') | date:'HH:mm' }}
                        <span class="eta-time-badge">{{ etaMinutesRemaining }} min</span>
                    }
                </span>
            </div>
            @if (!incident.incidentActions?.dtCompleted) {
            <div style="margin: 4px 0 8px;">
                <button nz-button nzType="default" nzSize="large" nzBlock (click)="isAddDelayModalVisible = true">
                    <nz-icon nzType="plus-circle" nzTheme="outline" />
                    Add Delay
                </button>
            </div>
            }
            @if (incident.incidentActions?.dtTechDelayAdded) {
            <div class="timeline-row" [class.done]="incident.incidentActions?.dtTechDelayAdded">
                <span class="timeline-label">Delay Added</span>
                <span class="timeline-value">{{ incident.incidentActions?.dtTechDelayAdded ? ((incident.incidentActions!.dtTechDelayAdded + 'Z') | date:'HH:mm') : '' }}</span>
            </div>
            @for (delay of incident.incidentDelays; track $index) {
            <div class="timeline-row done timeline-row-delay">
                <span class="timeline-label timeline-label-sub">+{{ delay.delayMinutes }} min</span>
                <span class="timeline-value timeline-value-sub">{{ delay.delayReason }}</span>
            </div>
            }
            }
            @if (!incident.incidentActions?.dtTechArrived) {
            <div style="margin: 4px 0 8px;">
                <button nz-button nzType="primary" nzSize="large" nzBlock (click)="onSetArrival()" [nzLoading]="isSettingArrival">
                    <nz-icon nzType="environment" nzTheme="outline" />
                    I've Arrived
                </button>
            </div>
            }
            <div class="timeline-row" [class.done]="incident.incidentActions?.dtTechArrived">
                <span class="timeline-label">Technician Arrived</span>
                <span class="timeline-value">
                    @if (incident.incidentActions?.dtTechArrived) {
                        <button nz-button nzType="link" nzSize="small" class="arrival-update-btn" (click)="isUpdateArrivalModalVisible = true">
                            {{ (incident.incidentActions!.dtTechArrived + 'Z') | date:'HH:mm' }}
                            <nz-icon nzType="reload" nzTheme="outline" />
                        </button>
                    } @else {
                        &nbsp;
                    }
                </span>
            </div>
            @if (incident.statusId >= 7 && incident.incidentActions?.dtTechArrived) {
                <div style="margin: 4px 0 8px;">
                    <button nz-button nzType="primary" nzSize="large" nzBlock (click)="onViewImages()">
                        <nz-icon nzType="file-image" nzTheme="outline" />
                        Add / View Images ({{ getImageCount() }})
                    </button>
                    @if (hasPendingImages()) {
                    <nz-alert nzType="warning" [nzMessage]="pendingImages.length + ' image(s) pending upload. They will sync automatically when online.'" nzShowIcon style="margin-top: 8px;"></nz-alert>
                    }
                    @if (hasExistingImages() && !incident.incidentActions?.dtCompleted) {
                        <button nz-button nzType="primary" nzSize="large" nzBlock [disabled]="hasPendingImages()" (click)="onCompleteIncident()" style="margin-top: 12px; background-color: #52c41a; border-color: #52c41a;">
                            <nz-icon nzType="check-circle" nzTheme="outline" />
                            Complete Incident
                        </button>
                    }
                </div>
            }
            <div class="timeline-row" [class.done]="incident.incidentActions?.dtCompleted">
                <span class="timeline-label">Technician Completed</span>
                <span class="timeline-value">{{ incident.incidentActions?.dtCompleted ? ((incident.incidentActions!.dtCompleted + 'Z') | date:'HH:mm') : '' }}</span>
            </div>
            @if (incident.incidentActions?.dtCompleted) {
            <div style="margin: 4px 0 8px;">
                <button nz-button nzType="primary" nzSize="large" nzBlock (click)="onClickProofOfWork()" [nzLoading]="isLoadingProofOfWork">
                    <nz-icon nzType="file-text" nzTheme="outline" />
                    View POW
                </button>
            </div>
            }
        </div>
    </div>
    }

    <!-- ===== SECTION 4: MAP ===== -->
    @if (mapUrl) {
    <div class="card map-card">
        <div class="map-container">
            <iframe
                [src]="mapUrl"
                width="100%"
                height="220"
                style="border:0;"
                allowfullscreen=""
                loading="lazy">
            </iframe>
        </div>
        <div style="margin-top: 12px;">
            <button nz-button nzType="default" nzSize="large" nzBlock (click)="onClickOpenGoogleMaps()">
                <nz-icon nzType="export" nzTheme="outline" />
                Navigate on Google Maps
            </button>
        </div>
    </div>
    }


    <!-- ===== BREAKDOWN DETAIL IMAGES ===== -->
    @if (getCategoryImages(5).length > 0 || getPendingImagesByCategory(5).length > 0) {
    <div class="card">
        <h2 class="card-title">
            <nz-icon nzType="file-image" nzTheme="outline" /> Breakdown Detail Images
        </h2>
        <div class="thumbnail-grid">
            @for (doc of getCategoryImages(5); track doc.documentId) {
                <div class="thumbnail-item" (click)="downloadImage(doc.localBase64 || doc.url, doc.description || 'image')">
                    <img [src]="doc.localBase64 || doc.url" [alt]="doc.description" />
                </div>
            }
            @for (img of getPendingImagesByCategory(5); track img.id) {
                <div class="thumbnail-item pending">
                    <img [src]="img.fileBase64" [alt]="img.name" />
                    <nz-tag [nzColor]="img.status === 'failed' ? 'red' : 'orange'" class="thumbnail-tag">
                        {{ img.status === 'failed' ? 'Failed' : 'Pending' }}
                    </nz-tag>
                </div>
            }
        </div>
    </div>
    }

    <!-- ===== SECTION 5: INCIDENT DETAILS ===== -->
    @if (incident) {
    <div class="card incident-details-card">
        <div class="incident-header">
            <h1 class="incident-title">
                <strong>#{{ incident.incidentNumber }}
                    @if (incident.orderNumber) {
                        / <span style="font-weight: bold;">{{ incident.orderNumber }}</span>
                    }
                </strong>
            </h1>
        </div>
        <div class="incident-details">
            <!-- ETA -->
            @if (incident.breakdownTechnicianDriverEta) {
            <div class="detail-row">
                <span class="detail-label"><nz-icon nzType="clock-circle" nzTheme="outline" /> ETA:</span>
                <span class="detail-value">{{ incident.breakdownTechnicianDriverEta + 'Z' | date:'HH:mm' }}</span>
            </div>
            }
            <!-- CLIENT & VEHICLE -->
            <div class="detail-row">
                <span class="detail-label"><nz-icon nzType="truck" nzTheme="outline" /></span>
                <span class="detail-value">{{ incident.transporterName || incident.clientName }} - {{ incident.fleetVehicle.registrationNumber || 'N/A' }}</span>
            </div>
            <!-- TYRES -->
            @if (incident.tyrePositions && incident.tyrePositions.length > 0) {
            <div class="detail-row">
                <span class="detail-label"><nz-icon nzType="tool" nzTheme="outline" /></span>
                <span class="detail-value">
                    @for (tyre of incident.tyrePositions; track tyre.tyreLocation) {
                        <div>
                            {{ tyre.sizeDescription }} - {{ getTyreLocationString(tyre.tyreLocation) }} (Qty: {{ tyre.qty }})
                            @if (incident.tyreBrandsText) {
                                    <small><strong>{{ incident.tyreBrandsText }}</strong> </small>
                                }

                        </div>
                    }
                    

                </span>
            </div>
            }
            <!-- DESCRIPTION -->
            @if (incident.incidentDescription) {
                <div class="detail-row detail-row-description">
                    <span class="detail-label"><nz-icon nzType="info-circle" nzTheme="outline" /> Description</span>
                    <span class="detail-value detail-value-description" style="white-space: pre-wrap;">
                        {{ showFullDescription ? incident.incidentDescription : getTruncatedDescription() }}
                        @if (incident.incidentDescription.length > DESCRIPTION_MAX_LENGTH) {
                            <button nz-button nzType="link" nzSize="small" (click)="toggleDescription()" style="padding: 0; height: auto;">
                                {{ showFullDescription ? 'Show Less' : 'Read More' }}
                            </button>
                        }
                    </span>
                </div>
            }
            <!-- DRIVER -->
            <div class="collapsible-section">
                <div class="section-toggle detail-row" (click)="toggleDriverDetails()">
                    <span>
                        <nz-icon nzType="user" nzTheme="outline" />
                        Driver:
                    </span>
                    <nz-icon [nzType]="showDriverDetails ? 'up' : 'down'" nzTheme="outline" />
                </div>
                @if (showDriverDetails) {
                <div class="section-content">
                    <div><strong>Name:</strong> {{ incident.driver.name || 'N/A' }}</div>
                    @if (incident.driver.phoneNumber) {
                    <div class="phone-row">
                        <span><strong>Phone:</strong> {{ incident.driver.phoneNumber }}</span>
                        <a [href]="getWhatsAppLink()" target="_blank" rel="noopener noreferrer">
                            <button nz-button nzSize="large" nzShape="circle" class="whatsapp-btn">
                                <nz-icon nzType="whats-app" nzTheme="outline" />
                            </button>
                        </a>
                    </div>
                    }
                </div>
                }
            </div>
            <!-- OPERATOR -->
            @if (getServiceProviderOperator()) {
            <div class="collapsible-section">
                <div class="section-toggle detail-row" (click)="toggleOperatorDetails()">
                    <span>
                        <nz-icon nzType="phone" nzTheme="outline" />
                        Operator:
                    </span>
                    <nz-icon [nzType]="showOperatorDetails ? 'up' : 'down'" nzTheme="outline" />
                </div>
                @if (showOperatorDetails) {
                <div class="section-content">
                    <div><strong>Name:</strong> {{ getServiceProviderOperator()!.name || 'N/A' }}</div>
                    @if (getServiceProviderOperator()!.cellNumber) {
                    <div class="phone-row">
                        <span><strong>Phone:</strong> {{ getServiceProviderOperator()!.cellNumber }}</span>
                        <a [href]="getOperatorWhatsAppLink()" target="_blank" rel="noopener noreferrer">
                            <button nz-button nzSize="large" nzShape="circle" class="whatsapp-btn">
                                <nz-icon nzType="whats-app" nzTheme="outline" />
                            </button>
                        </a>
                    </div>
                    }
                </div>
                }
            </div>
            }
        </div>
    </div>
    }

</div>
}

<!-- ===== VIEW IMAGES MODAL ===== -->
<nz-modal
    [(nzVisible)]="isViewImagesModalVisible"
    nzTitle="Incident Images"
    (nzOnCancel)="closeImagesModal()"
    nzWidth="90%"
    [nzFooter]="null">
    <ng-container *nzModalContent>
        <nz-collapse>
        @for (cat of imageCategories; track cat.categoryId) {
            <nz-collapse-panel [nzHeader]="nzCollapsePanelHeader">
                <ng-template #nzCollapsePanelHeader>
                    {{ cat.categoryName }} ({{ getCategoryImages(cat.categoryId).length }})
                    @if (getPendingImagesByCategory(cat.categoryId).length > 0) {
                        <nz-tag nzColor="orange" style="margin-left: 8px;">
                            {{ getPendingImagesByCategory(cat.categoryId).length }} Pending
                        </nz-tag>
                    }
                </ng-template>
                <div class="modal-photo-buttons">
                    <button nz-button nzType="default" nzSize="large" (click)="galleryInput.click()">
                        <nz-icon nzType="picture" nzTheme="outline" />
                        Select Images
                    </button>
                    <button nz-button nzType="default" nzSize="large" (click)="triggerCameraClick(cameraInput)">
                        <nz-icon nzType="camera" nzTheme="outline" />
                        Take Photo
                    </button>
                    <input #galleryInput type="file" accept="image/*" multiple (change)="onGallerySelect($event, cat)" style="display: none;" />
                    <input #cameraInput type="file" accept="image/*" capture="environment" (change)="onCameraCapture($event, cat)" style="display: none;" />
                </div>
                @for (doc of getCategoryImages(cat.categoryId); track doc.documentId) {
                    <div class="modal-image-card">
                        <div class="modal-image-wrapper">
                            <img [src]="doc.localBase64 || doc.url" [alt]="doc.description" />
                            <button nz-button nzSize="small" class="image-download-btn"
                                (click)="downloadImage(doc.localBase64 || doc.url, doc.description || 'image')">
                                <nz-icon nzType="download" nzTheme="outline" />
                            </button>
                            <button nz-button nzSize="small" class="image-delete-btn" nzDanger
                                [nzLoading]="removingDocumentId === doc.documentId"
                                (click)="onRemoveUploadedImage(doc.documentId)">
                                <nz-icon nzType="delete" nzTheme="outline" />
                            </button>
                        </div>
                        <div style="padding: 8px; background-color: #f5f5f5;">
                            <div class="image-card-footer">{{ doc.description }}</div>
                        </div>
                    </div>
                }
                @if (getPendingImagesByCategory(cat.categoryId).length > 0) {
                    <h4 class="pending-images-header">Pending Upload ({{ getPendingImagesByCategory(cat.categoryId).length }})</h4>
                    @for (img of getPendingImagesByCategory(cat.categoryId); track img.id) {
                        <div class="modal-image-card pending-image-card">
                            <div class="modal-image-wrapper">
                                <img [src]="img.fileBase64" [alt]="img.name" />
                                <button nz-button nzSize="small" class="image-download-btn"
                                    (click)="downloadImage(img.fileBase64, img.name)">
                                    <nz-icon nzType="download" nzTheme="outline" />
                                </button>
                                <button nz-button nzSize="small" class="image-delete-btn" nzDanger
                                    (click)="onRemovePendingImage(img.id!)">
                                    <nz-icon nzType="delete" nzTheme="outline" />
                                </button>
                            </div>
                            <div class="image-card-footer">
                                <span style="font-size: 12px; color: #666;">{{ img.name }}</span>
                                <nz-tag [nzColor]="img.status === 'failed' ? 'red' : 'orange'">
                                    {{ img.status === 'failed' ? 'Failed' : 'Pending' }}
                                </nz-tag>
                            </div>
                        </div>
                    }
                }
            </nz-collapse-panel>
        }
        </nz-collapse>
    </ng-container>
</nz-modal>

<!-- ===== ADD DELAY MODAL ===== -->
<nz-modal
    [(nzVisible)]="isAddDelayModalVisible"
    nzTitle="Add Delay"
    (nzOnCancel)="isAddDelayModalVisible = false"
    [nzOkLoading]="isAddingDelay"
    nzWidth="90%"
    [nzFooter]="addDelayFooter">
    <ng-container *nzModalContent>
        <div style="padding: 8px 0;">
            <div style="margin-bottom: 16px;">
                <label style="display: block; font-weight: 600; margin-bottom: 8px;">Minutes to add</label>
                <nz-input-number
                    [(ngModel)]="delayModalMinutes"
                    [nzMin]="5"
                    [nzStep]="5"
                    [nzFormatter]="minuteFormatter"
                    [nzParser]="minuteParser"
                    style="width: 100%;">
                </nz-input-number>
            </div>
            <div>
                <label style="display: block; font-weight: 600; margin-bottom: 8px;">Reason</label>
                <nz-radio-group [(ngModel)]="delayModalReason" nzButtonStyle="solid" style="width: 100%;">
                    @for (reason of delayReasons; track reason) {
                        <label nz-radio nzValue="{{ reason }}" style="display: block; margin-bottom: 8px;">{{ reason }}</label>
                    }
                </nz-radio-group>
            </div>
        </div>
    </ng-container>
    <ng-template #addDelayFooter>
        <button nz-button nzType="default" (click)="isAddDelayModalVisible = false">
            <nz-icon nzType="close" nzTheme="outline" />
            Cancel
        </button>
        <button nz-button nzType="primary" [nzLoading]="isAddingDelay" (click)="onConfirmAddDelay()" [disabled]="!delayModalMinutes || !delayModalReason">
            <nz-icon nzType="plus-circle" nzTheme="outline" />
            Add Delay
        </button>
    </ng-template>
</nz-modal>

<!-- ===== UPDATE ARRIVAL MODAL ===== -->
<nz-modal
    [(nzVisible)]="isUpdateArrivalModalVisible"
    nzTitle="Update Arrival Time"
    (nzOnCancel)="isUpdateArrivalModalVisible = false"
    [nzOkLoading]="isSettingArrival"
    nzWidth="90%"
    [nzFooter]="updateArrivalFooter">
    <ng-container *nzModalContent>
        <div style="padding: 16px 0; text-align: center;">
            <nz-icon nzType="environment" nzTheme="outline" style="color: #1890ff; font-size: 48px; margin-bottom: 16px;"></nz-icon>
            <p style="font-size: 16px; margin-bottom: 8px;"><strong>Update arrival time?</strong></p>
            <p style="color: #666;">This will overwrite the existing arrival time with the current time.</p>
        </div>
    </ng-container>
    <ng-template #updateArrivalFooter>
        <button nz-button nzType="default" (click)="isUpdateArrivalModalVisible = false">
            <nz-icon nzType="close" nzTheme="outline" />
            Cancel
        </button>
        <button nz-button nzType="primary" [nzLoading]="isSettingArrival" (click)="onConfirmUpdateArrival()">
            <nz-icon nzType="environment" nzTheme="outline" />
            Update Arrival
        </button>
    </ng-template>
</nz-modal>

<!-- ===== COMPLETE INCIDENT MODAL ===== -->
<nz-modal
    [(nzVisible)]="isCompleteIncidentModalVisible"
    nzTitle="Complete Incident"
    (nzOnCancel)="isCompleteIncidentModalVisible = false"
    [nzOkLoading]="isCompletingIncident"
    nzWidth="90%"
    [nzFooter]="completeModalFooter">
    <ng-container *nzModalContent>
        <div style="padding: 16px 0; text-align: center;">
            <nz-icon nzType="warning" nzTheme="outline" style="color: #fa8c16; font-size: 48px; margin-bottom: 16px;"></nz-icon>
            <p style="font-size: 16px; margin-bottom: 8px;"><strong>Are you sure you want to complete this incident?</strong></p>
            <p style="color: #666;">This action cannot be undone. Please ensure all work has been completed and documented.</p>
        </div>
    </ng-container>
    <ng-template #completeModalFooter>
        <button nz-button nzType="default" (click)="isCompleteIncidentModalVisible = false">
            <nz-icon nzType="close" nzTheme="outline" />
            Cancel
        </button>
        <button nz-button nzType="primary" [nzLoading]="isCompletingIncident" (click)="onConfirmCompleteIncident()" style="background-color: #52c41a; border-color: #52c41a;">
            <nz-icon nzType="check-circle" nzTheme="outline" />
            Complete Incident
        </button>
    </ng-template>
</nz-modal>
